<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>

<script>
import http from "@/api/public";
import $ from "jquery";
import { mapMutations, mapState } from "vuex";
import {clearCache} from "@/api/tdcGoods";
export default {
  name: "app",
  mounted() {
    // async function init() {
    //   // const resp = await http.fetchGet(
    //   //   "https://hcapi.shcaijiang.com/model/get-sdk-url/sdk@4.0.0.js"
    //   // );
    //   const { url } = resp;
    //   const script = document.createElement("script");
    //   try {
    //     await new Promise((resolve, reject) => {
    //       script.onload = resolve;
    //       script.onerror = reject;
    //       script.src = url;
    //       document.body.appendChild(script);
    //       script.parentNode.removeChild(script);
    //     });
    //   } catch (e) {
    //     throw new Error("init sdk fail!");
    //   }
    //   return global.__3d_sdk__;
    // }
    // init();
    let uniqueID = sessionStorage.getItem('uniqueID')
    if (!uniqueID||uniqueID=='undefined') {
      document.body.id = new Date().getTime()
      sessionStorage.setItem('uniqueID', document.body.id)
      var href = window.location.href
      var index=href.lastIndexOf("#");
      href = href.substring(index + 1, href.length);
      if (href == '/micro/microSaveUserData') {
        this.$router.replace('micro/microCustomization')
      }
      // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    }
    document.body.id = sessionStorage.getItem('uniqueID')
  },
  computed: {
    ...mapState(["clearCacheTdcIds","sdphase1"]),
  },
  methods: {
    // async beforeunloadHandler(e) {
    //   await clearCache({
    //     producrId: this.clearCacheTdcIds+'',
    //     editionId: this.sdphase1.editionType?this.sdphase1.editionType.mailyardId:''
    //   }).then((res) => { });
    //   window.close()
    // }
  },
  watch: {},
  // destroyed() {
  //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  // },
};
// document.oncontextmenu = new Function("return false;");
// document.onkeydown = document.onkeyup = document.onkeypress = function (event) {
//   var e = event || window.event || arguments.callee.caller.arguments[0];
//   if (e && e.keyCode == 123) {
//     e.returnValue = false;
//     return false;
//   }
// };
</script>

<style lang="scss" rel="stylesheet/scss">
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
  font-size: 0;
}
.clearfix {
  *zoom: 1;
}
.el-date-editor .el-range-separator {
  width: 12% !important;
}
#app {
  height: 100%;
}
.main {
  background: #ffffff;
  // min-width: 967px;
  min-width: 1366px;
  
}
body {
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue